import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        stroke: '#FFFFFF',
    },

    st1: {
        stroke: '#FFFFFF',
        strokeMiterlimit: '10',
    },

    st2: {
        fill: 'none',
    },

    st3: {
        fill: '#FFFFFF',
    },

    st4: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st5: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st6: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
